<template lang="html">
	<div class="tile-doc column" @click="download">
		<div class="ctn-icon-document">
			<img :src="baseFile" alt="">
			<span class="extension">.{{ doc.name | uppercase }}</span>
		</div>
		<div class="name">
			{{ doc.original_name }}
		</div>
		<div class="date" v-if="doc.created_at">
			Ajouté le {{ doc.created_at }}
		</div>
	</div>
</template>

<script>
// import emma from '@/common/services/Emma'
import BaseFile from '@/common/assets/img/icon.svg'
export default {
	name: 'TileDoc',
	props: ['doc'],
	data () {
		return {
			baseFile: BaseFile
		}
	},
	methods: {
		resolveReverseType (t) {
			let value = null
			switch (t) {
			case 'pdf':
				value = 'application/pdf'
				break
			case 'txt':
				value = 'application/octet-stream'
				break
			case 'doc':
				value = 'application/msword'
				break
			case 'docx':
				value = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
				break
			case 'xls':
				value = 'application/vnd.ms-excel'
				break
			case 'xlsx':
				value = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				break
			default:
				value = false
			}

			return value
		},
		download () {
			const win = window.open(process.env.API_ROOT + 'api/documents/' + this.doc.id)
			win.focus()
		}
	},
	filters: {
		uppercase: (value) => {
			return value.split('.')[value.split('.').length - 1].toUpperCase()
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// tile-doc.vue?19cd4eaa